// 圣经 66 卷分类体系与简写徽标映射

export const BIBLE_CATEGORIES_ZH = {
  ot: [
    {
      id: "all",
      label: "全部旧约",
      shortLabel: "全部",
      count: 39,
    },
    {
      id: "law",
      label: "摩西五经 (律法书)",
      shortLabel: "律法书",
      count: 5,
      books: ["创世记", "出埃及记", "利未记", "民数记", "申命记"],
    },
    {
      id: "history",
      label: "历史书",
      shortLabel: "历史书",
      count: 12,
      books: [
        "约书亚记",
        "士师记",
        "路得记",
        "撒母耳记上",
        "撒母耳记下",
        "列王纪上",
        "列王纪下",
        "历代志上",
        "历代志下",
        "以斯拉记",
        "尼希米记",
        "以斯帖记",
      ],
    },
    {
      id: "poetry",
      label: "诗歌·智慧书",
      shortLabel: "诗歌智慧",
      count: 5,
      books: ["约伯记", "诗篇", "箴言", "传道书", "雅歌"],
    },
    {
      id: "major_prophets",
      label: "大先知书",
      shortLabel: "大先知",
      count: 5,
      books: [
        "以赛亚书",
        "耶利米书",
        "耶利米哀歌",
        "以西结书",
        "但以理书",
      ],
    },
    {
      id: "minor_prophets",
      label: "小先知书",
      shortLabel: "小先知",
      count: 12,
      books: [
        "何西阿书",
        "约珥书",
        "阿摩司书",
        "俄巴底亚书",
        "约拿书",
        "弥迦书",
        "那鸿书",
        "哈巴谷书",
        "西番雅书",
        "哈该书",
        "撒迦利亚书",
        "玛拉基书",
      ],
    },
  ],
  nt: [
    {
      id: "all",
      label: "全部新约",
      shortLabel: "全部",
      count: 27,
    },
    {
      id: "gospels",
      label: "四福音书",
      shortLabel: "四福音",
      count: 4,
      books: ["马太福音", "马可福音", "路加福音", "约翰福音"],
    },
    {
      id: "acts",
      label: "教会历史",
      shortLabel: "教会历史",
      count: 1,
      books: ["使徒行传"],
    },
    {
      id: "pauline",
      label: "保罗书信",
      shortLabel: "保罗书信",
      count: 13,
      books: [
        "罗马书",
        "哥林多前书",
        "哥林多后书",
        "加拉太书",
        "以弗所书",
        "腓利比书",
        "歌罗西书",
        "帖撒罗尼迦前书",
        "帖撒罗尼迦后书",
        "提摩太前书",
        "提摩太后书",
        "提多书",
        "腓利门书",
      ],
    },
    {
      id: "general",
      label: "普通书信",
      shortLabel: "普通书信",
      count: 8,
      books: [
        "希伯来书",
        "雅各书",
        "彼得前书",
        "彼得后书",
        "约翰一书",
        "约翰二书",
        "约翰三书",
        "犹大书",
      ],
    },
    {
      id: "prophecy",
      label: "预言书 (启示录)",
      shortLabel: "启示录",
      count: 1,
      books: ["启示录"],
    },
  ],
};

export const BIBLE_CATEGORIES_EN = {
  ot: [
    {
      id: "all",
      label: "All Old Testament",
      shortLabel: "All",
      count: 39,
    },
    {
      id: "law",
      label: "Law (Pentateuch)",
      shortLabel: "Law",
      count: 5,
      books: ["Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy"],
    },
    {
      id: "history",
      label: "Historical Books",
      shortLabel: "History",
      count: 12,
      books: [
        "Joshua",
        "Judges",
        "Ruth",
        "1 Samuel",
        "2 Samuel",
        "1 Kings",
        "2 Kings",
        "1 Chronicles",
        "2 Chronicles",
        "Ezra",
        "Nehemiah",
        "Esther",
      ],
    },
    {
      id: "poetry",
      label: "Poetry & Wisdom",
      shortLabel: "Poetry",
      count: 5,
      books: ["Job", "Psalms", "Proverbs", "Ecclesiastes", "Song of Solomon"],
    },
    {
      id: "major_prophets",
      label: "Major Prophets",
      shortLabel: "Major Prophets",
      count: 5,
      books: ["Isaiah", "Jeremiah", "Lamentations", "Ezekiel", "Daniel"],
    },
    {
      id: "minor_prophets",
      label: "Minor Prophets",
      shortLabel: "Minor Prophets",
      count: 12,
      books: [
        "Hosea",
        "Joel",
        "Amos",
        "Obadiah",
        "Jonah",
        "Micah",
        "Nahum",
        "Habakkuk",
        "Zephaniah",
        "Haggai",
        "Zechariah",
        "Malachi",
      ],
    },
  ],
  nt: [
    {
      id: "all",
      label: "All New Testament",
      shortLabel: "All",
      count: 27,
    },
    {
      id: "gospels",
      label: "Gospels",
      shortLabel: "Gospels",
      count: 4,
      books: ["Matthew", "Mark", "Luke", "John"],
    },
    {
      id: "acts",
      label: "Acts",
      shortLabel: "Acts",
      count: 1,
      books: ["Acts"],
    },
    {
      id: "pauline",
      label: "Pauline Epistles",
      shortLabel: "Paul's Letters",
      count: 13,
      books: [
        "Romans",
        "1 Corinthians",
        "2 Corinthians",
        "Galatians",
        "Ephesians",
        "Philippians",
        "Colossians",
        "1 Thessalonians",
        "2 Thessalonians",
        "1 Timothy",
        "2 Timothy",
        "Titus",
        "Philemon",
      ],
    },
    {
      id: "general",
      label: "General Epistles",
      shortLabel: "General Letters",
      count: 8,
      books: [
        "Hebrews",
        "James",
        "1 Peter",
        "2 Peter",
        "1 John",
        "2 John",
        "3 John",
        "Jude",
      ],
    },
    {
      id: "prophecy",
      label: "Prophecy",
      shortLabel: "Revelation",
      count: 1,
      books: ["Revelation"],
    },
  ],
};

export const BOOK_ABBREVIATIONS = {
  // Chinese
  创世记: "创",
  出埃及记: "出",
  利未记: "利",
  民数记: "民",
  申命记: "申",
  约书亚记: "书",
  士师记: "士",
  路得记: "得",
  撒母耳记上: "撒上",
  撒母耳记下: "撒下",
  列王纪上: "王上",
  列王纪下: "王下",
  历代志上: "代上",
  历代志下: "代下",
  以斯拉记: "拉",
  尼希米记: "尼",
  以斯帖记: "斯",
  约伯记: "伯",
  诗篇: "诗",
  箴言: "箴",
  传道书: "传",
  雅歌: "歌",
  以赛亚书: "赛",
  耶利米书: "耶",
  耶利米哀歌: "哀",
  以西结书: "结",
  但以理书: "但",
  何西阿书: "何",
  约珥书: "珥",
  阿摩司书: "摩",
  俄巴底亚书: "俄",
  约拿书: "拿",
  弥迦书: "弥",
  那鸿书: "鸿",
  哈巴谷书: "哈",
  西番雅书: "番",
  哈该书: "该",
  撒迦利亚书: "亚",
  玛拉基书: "玛",
  马太福音: "太",
  马可福音: "可",
  路加福音: "路",
  约翰福音: "约",
  使徒行传: "徒",
  罗马书: "罗",
  哥林多前书: "林前",
  哥林多后书: "林后",
  加拉太书: "加",
  以弗所书: "弗",
  腓利比书: "腓",
  歌罗西书: "西",
  帖撒罗尼迦前书: "帖前",
  帖撒罗尼迦后书: "帖后",
  提摩太前书: "提前",
  提摩太后书: "提后",
  提多书: "多",
  腓利门书: "门",
  希伯来书: "来",
  雅各书: "雅",
  彼得前书: "彼前",
  彼得后书: "彼后",
  约翰一书: "约一",
  约翰二书: "约二",
  约翰三书: "约三",
  犹大书: "犹",
  启示录: "启",

  // English
  Genesis: "Gen",
  Exodus: "Exo",
  Leviticus: "Lev",
  Numbers: "Num",
  Deuteronomy: "Deu",
  Joshua: "Jos",
  Judges: "Jdg",
  Ruth: "Rut",
  "1 Samuel": "1Sa",
  "2 Samuel": "2Sa",
  "1 Kings": "1Ki",
  "2 Kings": "2Ki",
  "1 Chronicles": "1Ch",
  "2 Chronicles": "2Ch",
  Ezra: "Ezr",
  Nehemiah: "Neh",
  Esther: "Est",
  Job: "Job",
  Psalms: "Psa",
  Proverbs: "Pro",
  Ecclesiastes: "Ecc",
  "Song of Solomon": "Sng",
  Isaiah: "Isa",
  Jeremiah: "Jer",
  Lamentations: "Lam",
  Ezekiel: "Ezk",
  Daniel: "Dan",
  Hosea: "Hos",
  Joel: "Jol",
  Amos: "Amo",
  Obadiah: "Oba",
  Jonah: "Jon",
  Micah: "Mic",
  Nahum: "Nah",
  Habakkuk: "Hab",
  Zephaniah: "Zep",
  Haggai: "Hag",
  Zechariah: "Zec",
  Malachi: "Mal",
  Matthew: "Mat",
  Mark: "Mrk",
  Luke: "Luk",
  John: "Jhn",
  Acts: "Act",
  Romans: "Rom",
  "1 Corinthians": "1Co",
  "2 Corinthians": "2Co",
  Galatians: "Gal",
  Ephesians: "Eph",
  Philippians: "Php",
  Colossians: "Col",
  "1 Thessalonians": "1Th",
  "2 Thessalonians": "2Th",
  "1 Timothy": "1Ti",
  "2 Timothy": "2Ti",
  Titus: "Tit",
  Philemon: "Phm",
  Hebrews: "Heb",
  James: "Jas",
  "1 Peter": "1Pe",
  "2 Peter": "2Pe",
  "1 John": "1Jn",
  "2 John": "2Jn",
  "3 John": "3Jn",
  Jude: "Jud",
  Revelation: "Rev",
};

export const getBookAbbreviation = (bookName) => {
  if (!bookName) return "";
  return BOOK_ABBREVIATIONS[bookName] || bookName.slice(0, 2);
};

export const getBookCategory = (bookName, isEn = false) => {
  const categories = isEn ? BIBLE_CATEGORIES_EN : BIBLE_CATEGORIES_ZH;
  const allCats = [...categories.ot, ...categories.nt];
  for (const cat of allCats) {
    if (cat.books && cat.books.includes(bookName)) {
      return cat;
    }
  }
  return null;
};

export const filterBooksByCategory = (books, categoryId, testament = "all", isEn = false) => {
  if (!categoryId || categoryId === "all") {
    return books;
  }
  const categories = isEn ? BIBLE_CATEGORIES_EN : BIBLE_CATEGORIES_ZH;
  const list = testament === "ot" ? categories.ot : testament === "nt" ? categories.nt : [...categories.ot, ...categories.nt];
  const targetCat = list.find((c) => c.id === categoryId);
  if (!targetCat || !targetCat.books) return books;
  return books.filter((b) => targetCat.books.includes(b));
};
